"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgMfa = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M3 2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 1 1 0 2H3a3 3 0 0 1-3-3V3A3 3 0 0 1 .879.879m0 0A3 3 0 0 1 3 0h24a3 3 0 0 1 3 3v9a1 1 0 1 1-2 0V3a1 1 0 0 0-.293-.707l.707-.707-.707.707A1 1 0 0 0 27 2H3M15 9.5a.5.5 0 0 0 0-1v-1a1.5 1.5 0 0 0 0 3z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M15 7.5a1.5 1.5 0 0 1 0 3v-1a.5.5 0 0 1 0-1zM23 9.5a.5.5 0 0 0 0-1v-1a1.5 1.5 0 0 0 0 3z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M23 7.5a1.5 1.5 0 0 1 0 3v-1a.5.5 0 0 1 0-1zM7 9.5a.5.5 0 0 0 0-1v-1a1.5 1.5 0 1 0 0 3z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M7 7.5a1.5 1.5 0 1 1 0 3v-1a.5.5 0 0 1 0-1z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#D9EAF5", d: "M24 29.028a7.028 7.028 0 1 0 0-14.057 7.028 7.028 0 0 0 0 14.057" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M18.343 16.343a8 8 0 1 1 11.314 11.315 8 8 0 0 1-11.314-11.315M24 15.944a6.056 6.056 0 1 0 0 12.112 6.056 6.056 0 0 0 0-12.112", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#58627D", fillRule: "evenodd", d: "M24 17.849c.536 0 .972.435.972.972v2.721l1.771 1.772a.972.972 0 0 1-1.374 1.375l-2.057-2.057a.97.97 0 0 1-.285-.687V18.82c0-.537.436-.972.973-.972", clipRule: "evenodd" })));
exports.default = SvgMfa;
